import { render } from "./AboutTab.vue?vue&type=template&id=6dc75ed0&scoped=true"
import script from "./AboutTab.vue?vue&type=script&lang=js"
export * from "./AboutTab.vue?vue&type=script&lang=js"

import "./AboutTab.vue?vue&type=style&index=0&id=6dc75ed0&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-6dc75ed0"

export default script